<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div class="mt-3" *ngIf="expertMode">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Versicherungsbestätigung</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary"
            (click)="zusammenfassungService.korrektur($event, '#antrag_versicherungsbestaetigung', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row" *ngIf="kfzAntragComponent?.versicherungsbestaetigungComponent.vbvergabeart.value">
            <div class="col col-xs-12 col-sm-6">
              Hinterlegung der Versicherungsbestätigung durch:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ kfzAntragComponent.versicherungsbestaetigungComponent.vbvergabearten.get(kfzAntragComponent.versicherungsbestaetigungComponent.vbvergabeart.value) }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row" *ngIf="kfzAntragComponent?.versicherungsbestaetigungComponent.vbnummer.value">
            <div class="col col-xs-12 col-sm-6">
              Nummer der Versicherungsbestätigung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ kfzAntragComponent.versicherungsbestaetigungComponent.vbnummer.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="!expertMode && kfzAntragComponent?.versicherungsbestaetigungComponent.vbvergabeart.value">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Versicherungsbestätigung</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary"
            (click)="zusammenfassungService.korrektur($event, '#antrag_versicherungsbestaetigung', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungsbestätigung per E-Mail senden oder hinterlegen:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ kfzAntragComponent.versicherungsbestaetigungComponent.vbvergabeart.value === 1 ? 'Versand per E-Mail' : kfzAntragComponent.versicherungsbestaetigungComponent.vbvergabeart.value === 3 ? 'Direkte Hinterlegung (keine Abholung erforderlich)' : kfzAntragComponent.versicherungsbestaetigungComponent.ldstelle.value ? kfzAntragComponent.versicherungsbestaetigungComponent.ldstelle.value.Value : '' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Kraftfahrzeugdaten</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary"
            (click)="zusammenfassungService.korrektur($event, '#daten_kraftfahrzeugdaten', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row" *ngFor="let risiko of kfzAntragComponent?.risikoKfzComponents;let i=index">
            <div class="col col-xs-12 col-sm-12">
              <div class="header" *ngIf="kfzAntragComponent?.risikoKfzComponents.length > 1"><strong>Fahrzeug Nr {{ i + 1 }}:</strong></div>
            </div>
            <div class="col col-xs-12 col-sm-6">
              Fahrzeugart:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ risiko.fahrzeugart.value?.Value }}
            </div>
            <div class="col col-xs-12 col-sm-6">
              Marke, Handelsbezeichnung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ risiko.sonstigeMarke.value ? risiko.sonstigeMarke.value : risiko.marke.value?.Value}}, {{ risiko.modell.value }}
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.erstzulassungsdatum.value">
                <div class="col col-xs-12 col-sm-6">
                  Erstzulassungsdatum:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.erstzulassungsdatum.value.toDate() | date }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.hubraumCcm.value">
                <div class="col col-xs-12 col-sm-6">
                  Hubraum:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.hubraumCcm.value }} ccm
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.antriebsart.value">
                <div class="col col-xs-12 col-sm-6">
                  Antriebsart:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.antriebsart.value.Value }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.hybridart.value">
                <div class="col col-xs-12 col-sm-6">
                  Hybridart:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ dataService.hybridarten.get(risiko.hybridart.value * 1) }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.emissionCo2.value">
                <div class="col col-xs-12 col-sm-6">
                  CO₂-Ausstoß:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.emissionCo2.value }} g/km
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.leistungKw.value && risiko.leistungPs.value">
                <div class="col col-xs-12 col-sm-6">
                  Leistung:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.leistungKw.value }} kW ({{ risiko.leistungPs.value }} PS)
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.eigengewichtKg.value">
                <div class="col col-xs-12 col-sm-6">
                  Eigengewicht:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.eigengewichtKg.value }} kg
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.hoechstGeschwindigkeitKmh.value">
                <div class="col col-xs-12 col-sm-6">
                  Höchstgeschwindigkeit:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.hoechstGeschwindigkeitKmh.value }} km/h
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.anzahlPlaetze.value">
                <div class="col col-xs-12 col-sm-6">
                  Plätze:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.anzahlPlaetze.value }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.nutzlastKg.value">
                <div class="col col-xs-12 col-sm-6">
                  Nutzlast:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.nutzlastKg.value | number }} kg
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.gesamtgewichtKg.value">
                <div class="col col-xs-12 col-sm-6">
                  Gesamtgewicht:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.gesamtgewichtKg.value | number }} kg
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.fahrgestellnummer.value">
                <div class="col col-xs-12 col-sm-6">
                  Fahrgestellnummer:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.fahrgestellnummer.value | uppercase }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="risiko.verwendungsbestimmung.value">
                <div class="col col-xs-12 col-sm-6">
                  Verwendungsbestimmung:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ risiko.verwendungsbestimmung.value.Value }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="kfzAntragComponent.kennzeichen.value">
                <div class="col col-xs-12 col-sm-6">
                  Kennzeichen:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ kfzAntragComponent.kennzeichen.value | uppercase }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="kfzAntragComponent?.showBmStufeVerband">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Bonus-Malus-Stufe Verband:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  <div *ngIf="kfzAntragComponent?.bmStufeVerband?.Value">
                    {{ kfzAntragComponent.bmStufeVerband.Value }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="kfzAntragComponent?.showBmStufe">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  {{ (expertMode ? '' : 'Beantragte ') + 'Bonus-Malus-Stufe' + (expertMode ? ' Intern' : '') + ':' }}
                </div>
                <div class="col col-xs-12 col-sm-6">
                  <div *ngIf="kfzAntragComponent?.bmStufe?.Value">
                    {{ kfzAntragComponent.bmStufe.Value }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="showRegion">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fahrzeug ist/wird angemeldet in:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  <div *ngIf="kfzAntragComponent?.region?.Value">
                    {{ kfzAntragComponent.region?.Value }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="geburtsdatumZweiterZulassungsbesitzer?.value">
                <div class="col col-xs-12 col-sm-6">
                  Geburtsdatum des zweiten Zulassungsbesitzers:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ geburtsdatumZweiterZulassungsbesitzer.value | date }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Versicherungsumfang</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary"
            (click)="zusammenfassungService.korrektur($event, '#zusatzpakete', korrekturEvent)">Korrektur</button>
        </div>
        <div class="zusammenfassung-section-subsection">
          <h6 class="zusammenfassung-section-subheader">Haftpflicht</h6>
          <div class="col col-xs-12 col-sm-12">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                Versicherungssumme:
              </div>
              <div class="col col-xs-12 col-sm-6">
                <span class="custom_currency">
                  {{ kfzAntragComponent?.versicherungssummeVariante?.Value }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="zusammenfassung-section-subsection">
          <h6 class="zusammenfassung-section-subheader">Kasko-Versicherung</h6>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="!kfzAntragComponent?.interesseKaskoversicherung">
              <div class="col col-xs-12 col-sm-6">
                Kasko-Versicherung gewünscht:
              </div>
              <div class="col col-xs-12 col-sm-6 zusammenfassung-text-bold">
                Nein
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12" *ngIf="kfzAntragComponent?.interesseKaskoversicherung">
            <div class="row" *ngFor="let kasko of kfzAntragComponent?.kaskoKfzComponents;let i=index">
              <ng-container *ngIf="kasko.showKaskoversicherung()">
                <div class="col col-xs-12 col-sm-12">
                  <div class="header" *ngIf="kfzAntragComponent?.kaskoKfzComponents.length > 1">
                    <strong>
                      Fahrzeug
                      Nr {{ i + 1 }}:
                    </strong>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.kaskoVariante.value && kasko.kaskoVariante.value !== null">
                    <div class="col col-xs-12 col-sm-6">
                      Versicherungsart:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.versicherungsart }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.fahrzeugZustand.value">
                    <div class="col col-xs-12 col-sm-6">
                      Art des Fahrzeugs:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.fahrzeugZustand.value === "ja" ? 'Neufahrzeug' : 'Gebrauchtfahrzeug' }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row">
                    <div class="col col-xs-12 col-sm-6">
                      Neuwert-Listenpreis:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      <span class="custom_currency" *ngIf="kasko.listenpreis.value">
                        {{ kasko.listenpreis.value | customCurrency: 0 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row">
                    <div class="col col-xs-12 col-sm-6">
                      Wert der Sonderausstattung:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      <span class="custom_currency" *ngIf="kasko.sonderausstattung.value">
                        {{ kasko.sonderausstattung.value | customCurrency: 0 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.sonderausstattungDetails.value">
                    <div class="col col-xs-12 col-sm-6">
                      Sonderausstattung detailliert:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.sonderausstattungDetails.value }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.neuwertentschaedigung.value && this.kaskoVariante?.value.Key === '1'">
                    <div class="col col-xs-12 col-sm-6">
                      Neuwertentschädigung/KaskoPLUS:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.neuwertentschaedigung.value }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.leasingFahrzeug.value && this.kaskoVariante?.value.Key === '1'">
                    <div class="col col-xs-12 col-sm-6">
                      Leasingfahrzeug:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.leasingFahrzeug.value }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="expertMode && kasko.leasingklausel.value && this.kaskoVariante?.value.Key === '1'">
                    <div class="col col-xs-12 col-sm-6">
                      Leasingklausel:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.leasingklausel.value }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.evorsorgepaket.value">
                    <div class="col col-xs-12 col-sm-6">
                      E-Vorsorgepaket:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.evorsorgepaket.value | toCapLetter }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.vorsteuerabzugsberechtigt.value">
                    <div class="col col-xs-12 col-sm-6">
                      {{ expertMode ? 'Vorsteuerabzugsberechtigt:' : 'Liegt eine Berechtigung zum Vorsteuerabzug vor?'
                      }}
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.vorsteuerabzugsberechtigt.value | toCapLetter }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.selbstbehaltVariante.value || showKaskoPreselectValues(i)">
                    <div class="col col-xs-12 col-sm-6">
                      Selbstbehaltvariante:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ showKaskoPreselectValues(i) ? preselectedSbVariante : kasko.selbstbehaltVariante.value?.Value  }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.erhoehungSelbstbehalt.value || showKaskoPreselectValues(i)">
                    <div class="col col-xs-12 col-sm-6">
                      Selbstbehalt:
                    </div>
                    <div class="col col-xs-12 col-sm-6"> 
                      <span class="custom_currency">
                        {{ (kasko.selbstbehalthoehe | async)?.toString() | customCurrency: 0 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.vinkulierungFahrzeug.value">
                    <div class="col col-xs-12 col-sm-6">
                      Vinkulierung für Fahrzeug:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.vinkulierungFahrzeug.value | toCapLetter }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.vinkularglaeubiger.value">
                    <div class="col col-xs-12 col-sm-6">
                      Vinkulierung zu Gunsten:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.vinkularglaeubiger.value }}
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12">
                  <div class="row" *ngIf="kasko.leasingOrt.value">
                    <div class="col col-xs-12 col-sm-6">
                      Fahrzeug geleast bei:
                    </div>
                    <div class="col col-xs-12 col-sm-6">
                      {{ kasko.leasingOrt.value }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="zusammenfassung-section-subsection">
          <h6 class="zusammenfassung-section-subheader">Kfz-Insassenunfallversicherung</h6>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="!(kfzAntragComponent?.insassenVariante?.Value || kfzAntragComponent?.lenkerVariante?.Value)">
              <div class="col col-xs-12 col-sm-6">
                Kfz-Insassenunfallversicherung gewünscht:
              </div>
              <div class="col col-xs-12 col-sm-6 zusammenfassung-text-bold">
                Nein
              </div>
            </div>
            <div class="row" *ngIf="kfzAntragComponent?.insassenVariante?.Value || kfzAntragComponent?.lenkerVariante?.Value">
              <div class="col col-xs-12 col-sm-6">
                Art der Kfz-Insassenunfallversicherung:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ kfzAntragComponent?.insassenVariante?.Value ? 'Insassen' : 'Lenker' }}
              </div>
            </div>
            <div class="row" *ngIf="kfzAntragComponent?.insassenVariante?.Value || kfzAntragComponent?.lenkerVariante?.Value">
              <div class="col col-xs-12 col-sm-6">
                Gewähltes Paket:
              </div>
              <div class="col col-xs-12 col-sm-6" *ngIf="kfzAntragComponent?.insassenVariante?.Value">
                {{ kfzAntragComponent.insassenVariante?.Value }}
              </div>
              <div class="col col-xs-12 col-sm-6" *ngIf="kfzAntragComponent?.lenkerVariante?.Value">
                {{ kfzAntragComponent.lenkerVariante?.Value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Antragsinformationen</h6>
        </div>
        <div class="zusammenfassung-section-subsection">
          <div class="row">
            <div class="col col-xs-12 col-sm-8">
              <h6 class="zusammenfassung-section-subheader">Allgemeine Daten</h6>
            </div>
            <div class="col col-xs-12 col-sm-4 text-right pr-3">
              <button mat-button class="button--primary"
                (click)="zusammenfassungService.korrektur($event, '#antrag_kennzeichen', korrekturEvent)">Korrektur</button>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="kfzAntragComponent?.kaskoKfzComponents.first?.bmStufeKasko.value !== null">
              <div class="col col-xs-12 col-sm-6">
                Abweichende Bonus-Malus-Stufe:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ kfzAntragComponent?.kaskoKfzComponents.first.bmStufeKasko.value?.Value }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row">
              <div class="col col-xs-12 col-sm-6">
                Kennzeichen:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ kfzAntragComponent?.kennzeichen?.value | uppercase }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="expertMode">
              <div class="col col-xs-12 col-sm-6">
                Antragsart:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ dataService.antragsarten.get(antragsart) }}
              </div>
            </div>
          </div>
        </div>
        <div class="zusammenfassung-section-subsection">
          <div class="row">
            <div class="col col-xs-12 col-sm-8">
              <h6 class="zusammenfassung-section-subheader">Letzte Haftpflichtversicherung</h6>
            </div>
            <div class="col col-xs-12 col-sm-4 text-right pr-3">
              <button mat-button class="button--primary"
                (click)="zusammenfassungService.korrektur($event, '#antrag_hdiKfzMotorradVersicherungLabel', korrekturEvent)">Korrektur</button>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row">
                <div class="col col-xs-12 col-sm-12" *ngIf="kfzAntragComponent?.hdiKfzMotorradVersicherung.value">
                  <div class="col col-xs-12 col-sm-12">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        HDI Kfz-Versicherung innerhalb des letzten Jahres:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '1' | boolToJaNein }}
                      </div>
                    </div>
                  </div>
                  <div class="col col-xs-12 col-sm-12" *ngIf="kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '1'">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        Polizzennummer bei HDI:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent.hdiPolizzennummer.value }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-xs-12 col-sm-12"
                     *ngIf="kfzAntragComponent?.vorversicherungComponent?.vorversicherungsUnternehmen.value ||
                     kfzAntragComponent?.vorversicherungComponent?.sonstigeVersicherung?.value">
                  <div class="col col-xs-12 col-sm-12">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        Bisherige Versicherung:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.vorversicherungComponent?.sonstigeVersicherung?.value ?
                        kfzAntragComponent?.vorversicherungComponent?.sonstigeVersicherung?.value :
                        kfzAntragComponent?.vorversicherungComponent?.vorversicherungsUnternehmen?.value ?
                        kfzAntragComponent?.vorversicherungComponent?.vorversicherungsUnternehmen?.value.Value : '' }}
                      </div>
                    </div>
                  </div>
                  <div class="col col-xs-12 col-sm-12">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        Polizzennummer bei Vorversicherung:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.vorversicherungComponent?.polizzennummerVorversicherung?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="col col-xs-12 col-sm-12" *ngIf="showBmStufe">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        Bonus-Malus-Stufe bei Vorversicherung:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.bmStufenVorversicherung?.get(kfzAntragComponent?.bmStufeVorversicherung?.value) }}
                      </div>
                    </div>
                  </div>
                  <div class="col col-xs-12 col-sm-12" *ngIf="showOffeneSchaeden">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        {{ expertMode ? 'Schäden nach dem Beobachtungszeitraum:' : 'Offene Schäden:' }}
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.firstSchadenZeitpunkt?.value ? zusammenfassungService?.offeneSchaeden(kfzAntragComponent?.firstSchadenZeitpunkt?.value,
                        kfzAntragComponent?.secondSchadenZeitpunkt?.value, kfzAntragComponent?.thirdSchadenZeitpunkt?.value) : 'keine' }}
                      </div>
                    </div>
                  </div>
                  <div class="col col-xs-12 col-sm-12">
                    <div class="row">
                      <div class="col col-xs-12 col-sm-6">
                        Stornodatum des Vorvertrags:
                      </div>
                      <div class="col col-xs-12 col-sm-6">
                        {{ kfzAntragComponent?.stornodatumVorvertrag?.value | date }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="zusammenfassung-section-subsection">
          <div class="row" *ngIf="kfzAntragComponent?.interesseKaskoversicherung && kfzAntragComponent?.kaskoVorversicherung?.value">
            <div class="col col-xs-12 col-sm-8">
              <h6 class="zusammenfassung-section-subheader">Letzte Kaskoversicherung</h6>
            </div>
            <div class="col col-xs-12 col-sm-4 text-right pr-3">
              <button mat-button class="button--primary"
                      (click)="zusammenfassungService.korrektur($event, '#antrag_vorherigeKaskoVersicherung', korrekturEvent)">
                Korrektur
              </button>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="kfzAntragComponent?.interesseKaskoversicherung && kfzAntragComponent?.kaskoVorversicherung?.value">
              <div class="col col-xs-12 col-sm-6">
                In den letzten 3 Jahren kaskoversichert:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{
 kfzAntragComponent.kaskoVorversicherung.value === '1' ? 'Ja, gleich wie Haftpflicht' :
                kfzAntragComponent.kaskoVorversicherung.value === '2' ? 'Ja, abweichend von Haftpflicht' :
                kfzAntragComponent.kaskoVorversicherung.value === '3' ? 'Nein' : ''
                }}
              </div>
            </div>
          </div>
          <div *ngIf="kfzAntragComponent?.kaskoVorversicherungComponent?.sonstigeVersicherung.value || kfzAntragComponent?.kaskoVorversicherungComponent?.vorversicherungsUnternehmen.value">
            <div class="col col-xs-12 col-sm-12">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Bisherige Versicherung:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{
 kfzAntragComponent.kaskoVorversicherungComponent.sonstigeVersicherung.value ?
                  kfzAntragComponent.kaskoVorversicherungComponent.sonstigeVersicherung.value :
                  kfzAntragComponent.kaskoVorversicherungComponent.vorversicherungsUnternehmen.value ?
                  kfzAntragComponent.kaskoVorversicherungComponent.vorversicherungsUnternehmen.value.Value : ''
                  }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="kfzAntragComponent?.kaskoVorversicherungComponent?.polizzennummerVorversicherung.value">
                <div class="col col-xs-12 col-sm-6">
                  Bisherige Polizzennummer:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ kfzAntragComponent.kaskoVorversicherungComponent.polizzennummerVorversicherung.value }}
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12">
              <div class="row" *ngIf="kfzAntragComponent?.kaskoVorversicherungComponent?.polizzennummerVorversicherung.value">
                <div class="col col-xs-12 col-sm-6">
                  Stornodatum der Versicherung:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ kfzAntragComponent.kaskoStornodatumVorvertrag.value | date}}
                </div>
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="showAnzahlKaskoSchaeden">
              <div class="col col-xs-12 col-sm-6">
                Kaskoschäden:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ kfzAntragComponent.kaskoschaedenAnzahl.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="expertMode && datenBeratungsprotokollComponent?.beratungsprotokoll.value">
    <div class="zusammenfassung-section">
      <h6>Beratungsprotokoll</h6>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Beratungsprotokoll erstellen:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ datenBeratungsprotokollComponent.beratungsprotokoll.value | toCapLetter }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="expertMode && antragWeitereFragenComponent?.gekuendigteVorversicherungComponent?.vorversicherungsUnternehmen.value">
    <div class="zusammenfassung-section">
      <h6> {{ expertMode ? 'Wurde die Versicherung der beantragten Risiken bereits gekündigt, abgelehnt oder einvernehmlich gelöst?' : 'Wurde Ihnen bereits die Versicherung der beantragten Risiken gekündigt, abgelehnt oder einvernehmlich gelöst?' }}</h6>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Gesellschaft:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ antragWeitereFragenComponent.gekuendigteVorversicherungComponent?.vorversicherungsUnternehmen.value?.Value }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Polizzennummer:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ antragWeitereFragenComponent.gekuendigteVorversicherungComponent?.polizzennummerVorversicherung.value }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Datum der Kündigung/Ablehnung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ antragWeitereFragenComponent.datumKuendigung.value?.toDate() | date }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Grund der Kündigung/Ablehnung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ antragWeitereFragenComponent.grundKuendigung.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row zusammenfassung-misc-questions">
    <div class="col col-xs-12 col-sm-12">
      <app-textarea #_besondereAnmerkungen [parentFormGroupDirective]="parentFormGroupDirective" [control]="besondereAnmerkungen" id="besondereAnmerkungen" label="Besondere Anmerkungen:"></app-textarea>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <app-vereinbarung-kommunikation [parentFormGroupDirective]="parentFormGroupDirective" [vereinbarungKommunikation]="vereinbarungKommunikation" [antrag]="true" [expertMode]="expertMode"></app-vereinbarung-kommunikation>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <app-datenschutz-policy [parentFormGroupDirective]="parentFormGroupDirective" [datenschutzPolicy]="datenschutzPolicy" [showDatenschutzPolicy]="!expertMode" [produktArt]="motorrad? produktArt.Motorrad : produktArt.Kfz"></app-datenschutz-policy>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input_checkbox">
        <mat-checkbox formControlName="allgemeineVertragsgrundlagen">
          {{ expertMode ? 'Der Versicherungsnehmer erkennt die' : 'Ich erkenne die' }} <a [href]="translateService.get('LINKALLGEMEINEVERTRAGGRUNDLAGENKFZMRAD') | async" class="textLink" target="blank">allgemeinen Vertragsgrundlagen</a> und die <a [href]="translateService.get('LINKSPARTENBEZOGENEVERSICHERUNGSBEDINGUNGEN') | async" class="textLink" target="_blank">spartenbezogenen Versicherungsbedingungen</a> für das gewählte Versicherungsprodukt/die gewählten Versicherungsprodukte an. *
        </mat-checkbox>
        <mat-error *ngIf="allgemeineVertragsgrundlagen.hasError('required') && (allgemeineVertragsgrundlagen.touched || parentFormGroupDirective.submitted)">
          {{ 'CONFIRMREQUIRED' | translate }}
        </mat-error>
      </div>
    </div>
  </div>
</form>
